import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { formatArrivalDate } from '../../../../../../utils/Functions';
import { ItineraryService } from '../../../../../../shared/itinerary.service';
import { RestService } from '../../../../../../shared/rest.service';
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from 'ngx-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../../../../../shared/modals/confirmation-modal/confirmation-modal.component';
import { MaterialModalConfirmComponent } from '../../../../../../shared/material-modal-confirm/material-modal-confirm.component';
import * as moment from 'moment';
import { ModalsComponent } from '../../../../../../shared/modals/modals.component';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ModalLoadingComponent } from 'app/shared/modal-loading/modal-loading.component';
import { MaterialModalAlertComponent } from 'app/shared/material-modal-alert/material-modal-alert.component';
import { ResultsSearchService } from 'app/home/results-search.service';
import { Router } from '@angular/router';
// import { waitForAsync } from '@angular/core/testing';

@Component({
  selector: 'usb-item-tours',
  templateUrl: './item-tours.component.html',
  styleUrls: ['./item-tours.component.scss'],
  providers: [DynamicFontSizePipe, CurrencyConverterPurePipe]
})
export class ItemToursComponent implements OnInit {
  @Input() dato: any;
  @Input() isCheckIn: boolean;
  @Input() partialReserve: boolean;
  @Input() clientSetting: any;
  @Input() permissions: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() itemDelete = new EventEmitter<any>();
  @Output() reSearch = new EventEmitter<any>();
    @Output() delete = new EventEmitter<string>();
    @Output() cancel = new EventEmitter<string>();


  @ViewChild('modalRooms') modalRooms: ModalDirective;

  public formatDate = formatArrivalDate;
  iconsTourDisabled:boolean = false;
  fontSizeAdjustments = { 6: -1, 8: -2, 10: -5 };
  public styleSidebar: any;
    bsModalRef?: BsModalRef;

  constructor(private itineraryService: ItineraryService,
              private currencyPipe: CurrencyConverterPurePipe,
              private restService :RestService,
              public userService : UserService,
              private modalService: BsModalService,
              private ngxSpinner: NgxSpinnerService,
              private toastr: ToastrService,
              private resultsSearch: ResultsSearchService,
              private router: Router,
              public dialog: MatDialog) { }

  ngOnInit() {
    // console.log("dato tour", this.dato);
    // this.getProduct();
      this.styleSidebar = JSON.parse(this.clientSetting.clients_setting_app_booking?.bookingFlow_sidebar);
    console.log("DATO: ", this.dato);
  }

  getProduct(){

    if (this.dato.payloadUpdate) {
      // console.log('/search/products------------------> getProduct ItemToursComponent',  this.dato.payloadUpdate);
      this.restService.doPost('app', 'search/products', this.dato.payloadUpdate).subscribe(
        (response:any) => {
          if (response && response.status && response.results) {
            if (response.results !== undefined) {
              this.dato.product = response.results[0];
            } else {
              this.dato.product = response.results;
            }
          }

          //console.log("this.dato tour actualizado", this.dato);
        }, error => {
          console.log(error.message);
        }
      );
    }
  }

  removeItem(item: any) {
    let message = "";

    if ((item.status_id == 1) ||  (item.status_id == 5)) {
      message = "Esta seguro de Eliminar el Producto?";
    }
    if (item.status_id == 2) {
        message = "¿Esta seguro de cancelar el producto?";

    }

    const initialState: ModalOptions = {
      initialState: {
        title: item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
          const paxesQty = {
            destination: item.destination?.iata_code,
            adults: Number(item.paxAdults),
            children: Number(item.paxChildren)
          }
          this.userService.itineraryActive[0]['destination'].forEach((destination: any) => {
              if(destination.iata_code === paxesQty.destination) {
                destination.destination_info.adults -= paxesQty.adults;
                destination.destination_info.childs -= paxesQty.children;
              }
          });
        if((item.status_id == 1) ||  (item.status_id == 5) ) {

          this.deleteItem(item);
        }
        if (item.status_id == 2) {
          this.cancelReservation(item);
        }
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

   deleteItem(item: any) {
    this.itineraryService.remove(item !== undefined ? item : item);
    setTimeout(() => {
      this.delete.emit(item.id);
     this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

  cancelReservation(item: any) {



this.ngxSpinner.show();
const productsIdArr = [item.id];
let cancelData: any = {};
switch(item?.category_id) {
  case 1:
    cancelData['providerId'] = item?.providerId
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    break;
  case 2:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.additionalInfo?.idReservation;
    break;
  case 6:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    cancelData['productsId'] = productsIdArr;
    break;
  case 8:
    cancelData['providerId'] = item?.providerId
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    break;

}

console.log(JSON.stringify(cancelData));
const itemCancellation = this.userService.itineraryActive[0].items.find(c => c.id === item.id);

itemCancellation.amount_convert_cancellation= this.getCancellationPolicies(itemCancellation.category_id, item);
this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

   this.restService.doPut("app", `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
    next: (res: any) => {
      this.ngxSpinner.hide();
      console.log(res);
      this.toastr.success('Su producto fue cancelado con éxito');
      this.cancel.emit(item.id);


      this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
    },
    error: (error: HttpErrorResponse) => {
      this.ngxSpinner.hide();
      this.toastr.error('Ocurrio un error');
      console.log(error);
    }
  });
  }

  getCancellationPolicies(category, item) {
    const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies = [];
    if (category === 1) {
        policies = item.room?.cancellationPolicy || [];
    } else if (category === 6 || category === 8) {
        policies = item.cancellationPolicies || [];
    }

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }

    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amount = (policy.amount / baseRate) * targetRate;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amount: amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amount: (policy.amount / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
            apply: false
        }));
    }

    return result;
}

  toPartialReserve(event, item: any){
    if ( event.target.checked ) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item,true);
      this.itemToPartial.emit(-1);
    }
  }

  subtractDays(date){
    return moment(moment(date)).subtract(2, 'days').format('YYYY-MM-DD');
  }

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str){
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

  openModal() {
    var dialogRef = this.dialog.open(ModalsComponent, {
      height: '680px',
      width: '800px',
      data: {
        product: this.dato.product,
        productQty: "1",
        //form: this.activeItineraryForm,
        origin: 'HOTELS',
        itineraryItem:this.dato,
        view_info:true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      // if(result){


      // }else{

      // }
    });
  }

  edit(item: any){
    console.log(item)
    console.log(this.dato);
    const message = '¿Deseas eliminar este producto y buscar un nuevo '+ this.dato.categoryName + ' en ' + this.dato.location + ' del ' + this.returnDate(this.dato.arrivalDate) + ' hasta ' +  this.returnDate(this.dato.departureDate) +' para ' + this.dato.paxAdults + ' adultos?';



      const initialState: ModalOptions = {
        initialState: {
          title: 'Eliminar',
          message: message.replace(/\?/g, '?<br />'),
          icon: 'assets/icons/itinerary-detail/04-01.svg'
        }
      };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
      if(result){
         await this.makePayload(item);
          await this.itineraryService.remove(item !== undefined ? item : item);
      }else{

      }
        confirmSubscription.unsubscribe();
    });
  }

  makePayload(item: any) {
      const _payload = [];

      const  payload = item.payloadUpdate.products[0];
      const form = item.form;
      _payload[0] = payload;

      localStorage.setItem("form", JSON.stringify(form));
      localStorage.setItem("payload", JSON.stringify(_payload));
      this.openModalLoading(JSON.parse(localStorage.getItem("payload")));
      this.restService.doPost("app", "search", payload).subscribe(
              (response: any) => {
                // console.log('response ->', response);

                if (response !== null && response.results !== null) {
                  // console.log('payload ->', payload);

                  const payloadArray = [payload];
                  this.resultsSearch._setPayload(payloadArray);
                  localStorage.setItem("form", JSON.stringify(form));
                  localStorage.setItem("payload", JSON.stringify(payloadArray));
                  this.resultsSearch._setOrigin(item.categoryName);

                  this._setSearchIdInResults(response);
                  if (response.results.length > 0) {
                    this._handleResponse(response, item.categoryName, item);
                    this.dialog.closeAll();
                    this.itineraryService.notifyModalClosed(true);
                    setTimeout(() => {
                      this.router.navigate(["/results"]);
                    }, 200);
                  } else {
                    var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                      height: "auto",
                      width: "350px",
                      data: "No se encontraron Resultados",
                      disableClose: true,
                    });
                  }
                }
              },
              (error) => {
                const message = "Ocurrió un error al intentar encontrar productos";
                this.dialog.closeAll();
                var dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
                  width: "450px",
                  data: {message: message},
                  disableClose: true,
                });
                dialogRef.afterClosed().subscribe((result) => {
                  if (result) {
                    this.makePayload(item);
                  } else {
                    this.dialog.closeAll();
                  }
                });
              }
            );
    }

      _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

  _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = payload.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = "No results found for the search";
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log("error", e);
      }
    }
  }


        /// modal loading
        openModalLoading(data: any) {
          var dialogRef = this.dialog.open(ModalLoadingComponent, {
            width: "650px",
            id: "loadModal",
            data: data,
            disableClose: true,
          });

          /* dialogRef.afterClosed().subscribe(result => {
            });*/
        }

  returnDate(date){
    let dateSplit = date.split("-");
    return '' + dateSplit[2] + '-' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
  }

  fontPrice(price){
    if(price) {
      if((price.length - 6) > 0){
        const fact = price.length - 6
        const size = 25 - (1.5 * fact)
        return size + 'px'
      }

    }
  }

    getPrice(item): number {

      if(item.status_id == 5) {
        return 0;
      }

      let price: number;

      if(!item.isPendigApprovePay && !item.isPaidAgency && !item.isPaidProvider) {
        price = item.netPriceAgent;
        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );
      }

      if(item.isPendigApprovePay || item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          price = item.converted_amounts.netPriceAgent;
        } else {
          price = item.netPriceAgent;
        }


      }

      return price

    }


getDuration(duration: string): string {
  if (!duration) return 'Duración no disponible';

  try {
    const [time, type] = duration.split('-').map(part => part.trim());
    const timeNumber = parseInt(time, 10);

    if (isNaN(timeNumber)) return 'Duración inválida';

    // Mapeo de tipos a sus formas singular y plural
    const timeMap: { [key: string]: { singular: string, plural: string } } = {
      'DAYS': { singular: 'día', plural: 'días' },
      'HOURS': { singular: 'hora', plural: 'horas' },
      'MINUTES': { singular: 'minuto', plural: 'minutos' }
    };

    const timeType = type.toUpperCase();
    const timeConfig = timeMap[timeType];

    if (timeConfig) {
      const spanishType = timeNumber === 1 ? timeConfig.singular : timeConfig.plural;
      return `${timeNumber} ${spanishType}`;
    } else {
      // Para tipos no mapeados, usar el original
      return `${timeNumber} ${type.toLowerCase()}`;
    }

  } catch (error) {
    console.error('Error en getDuration:', error);
    return 'Error en duración';
  }
}

}
